import React from 'react';

/**
 * Page representing an agent's Analytics.
 */
export const Analytics = () => {
  return (
    <div>
      <h2>Analytics</h2>
    </div>
  );
};
